import React from "react";
import PageHero from "../components/PageHero";
import SectionHeader from "../components/SectionHeader";
import CTASection from "../components/CTASection";
import { CheckCircle2 } from "lucide-react";
import { INDUSTRIES, WHY_US } from "../lib/constants";

export default function About() {
  return (
    <div>
      <PageHero
        kicker="About Us"
        title="Institutional Supply, Procurement & Infrastructure Partner"
        description="Bengaluru-based company supporting government departments, residential schools, hostels, educational institutions, offices, corporates, and bulk buyers across multiple categories."
        primary={{ to: "/submit", label: "Submit Requirement" }}
        secondary={{ to: "/government-contractor", label: "Vendor Profile" }}
      />

      <section className="section">
        <div className="container-x grid lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2 space-y-4 text-[var(--melopa-text)] text-[15px] leading-relaxed">
            <p>
              Melopa Invents Pvt Ltd is a Bengaluru-based institutional supply, procurement, infrastructure, and project fulfilment company serving government departments, residential schools, hostels, educational institutions, offices, corporates, and bulk buyers.
            </p>
            <p>
              The company supports multiple categories including FMCG, beverages, dairy products, food products, electronics, IT equipment, smart classroom solutions, CCTV, UPS, battery systems, solar solutions, lighting, furniture, kitchen supplies, stationery, and requirement-based institutional procurement.
            </p>
            <p>
              Melopa Invents works through sourcing networks, channel partnerships, logistics capability, and technical execution partners wherever required. The company’s objective is to provide reliable, timely, and requirement-based fulfilment for institutional and government procurement needs.
            </p>
          </div>
          <aside className="card-premium p-6 h-fit">
            <div className="kicker mb-2">Our Mission</div>
            <h3 className="text-xl font-bold text-navy">Reliable institutional fulfilment</h3>
            <div className="divider-gold" />
            <p className="text-sm text-[var(--melopa-muted)]">
              Be the trusted single-window procurement and infrastructure partner for institutions and government departments across Karnataka and India.
            </p>
          </aside>
        </div>
      </section>

      <section className="section bg-soft">
        <div className="container-x grid lg:grid-cols-2 gap-10">
          <div>
            <SectionHeader kicker="Our Capabilities" title="Multi-category procurement & execution support" />
            <ul className="list-tick mt-2">
              {WHY_US.map((w) => <li key={w}>{w}</li>)}
            </ul>
          </div>
          <div>
            <SectionHeader kicker="Our Approach" title="Institutional & tender-ready process" subtitle="Documentation, sourcing, partner-led execution, and follow-through — designed to match procurement workflows." />
            <div className="grid sm:grid-cols-2 gap-3 mt-2">
              {[
                { t: "Requirement Capture", d: "Detailed scoping with quantity, location, deadline." },
                { t: "Sourcing Network", d: "OEMs, channel partners, qualified vendors." },
                { t: "Documentation", d: "Tender support, certificates, authorisations." },
                { t: "Execution Support", d: "Project coordination through licensed partners." },
              ].map((s) => (
                <div key={s.t} className="card-premium p-4">
                  <div className="font-semibold text-navy">{s.t}</div>
                  <p className="text-xs text-[var(--melopa-muted)] mt-1">{s.d}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container-x">
          <SectionHeader kicker="Industries We Serve" title="Government, Institutional & Bulk Buyers" />
          <div className="flex flex-wrap gap-2 mt-6">
            {INDUSTRIES.map((i) => (
              <span key={i} className="badge-soft">
                <CheckCircle2 className="w-3.5 h-3.5 text-[var(--melopa-green)]" /> {i}
              </span>
            ))}
          </div>
        </div>
      </section>

      <CTASection
        title="Looking for a procurement partner?"
        description="Share your requirement and we will revert with the right solution and quote."
      />
    </div>
  );
}
